import { LightDefinitions } from './light';
import { CameraDefinitions } from './camera';
import { EffectDefinitions } from './effect';
import { MeshDefinitions } from './mesh';
import { MaterialDefinitions } from './materials';
import { LinkDefinitions } from './link';

export const ItemDefinitions = {
    ...CameraDefinitions,
    ...MeshDefinitions,
    ...LightDefinitions,
    ...EffectDefinitions,
    ...MaterialDefinitions,
    ...LinkDefinitions
} as const;

export type ItemDefinitionType = keyof typeof ItemDefinitions; 